export const texts = {
  edit: { de: 'Bearbeiten', en: 'Edit' },
  changeToMustHave: { de: 'Ändern in Must-Have', en: 'Change to Must-Have' },
  changeToNiceToHave: { de: 'Ändern in Nice-to-Have', en: 'Change to Nice-to-Have' },
  mergeOr: { de: 'Zusammenführen (ODER)', en: 'Merge (OR)' },
  splitAnd: { de: 'Aufteilen (UND)', en: 'Split (AND)' },
  delete: { de: 'Löschen', en: 'Delete' },
  addAlternative: { de: 'Alternative hinzufügen', en: 'Add alternative' },
  type: { de: 'Typ', en: 'Type' },
  ignore: { de: 'Ignorieren', en: 'Ignore' },
  hide: { de: 'Verstecken', en: 'Hide' },
  yes: { de: 'Ja', en: 'Yes' },
  no: { de: 'Nein', en: 'No' },
  ok: { de: 'Ok', en: 'Ok' },
  editExperienceTitle: { de: 'Berufserfahrung bearbeiten', en: 'Edit work experience' },
  minExperience: { de: 'Minimale Berufserfahrung', en: 'Minimum work experience' },
  editLanguageTitle: { de: 'Sprache bearbeiten', en: 'Edit language' },
  languageLabel: { de: 'Sprache', en: 'Language' },
  german: { de: 'Deutsch', en: 'German' },
  english: { de: 'Englisch', en: 'English' },
  level: { de: 'Level', en: 'Level' },
  basic: { de: 'Grundkenntnisse', en: 'Basic' },
  good: { de: 'Gut', en: 'Good' },
  fluent: { de: 'Fließend', en: 'Fluent' }
};
